import Parse from "parse";
import { getClassName, filterKeys } from "./ParseConfiguration";
import { handleError } from "./ErrorHandler.ts";
import { setLimit } from "./ParseConfiguration";
import { EventCategoriesModel, EventCategories } from "../Models/EventCategoriesModel.ts";


const EVENT_CATEGORIES_TABLE: any = getClassName("EventCategories")


export async function getEventCategories(): Promise<EventCategoriesModel[]> {
  try {
    const query = new Parse.Query(EVENT_CATEGORIES_TABLE)
    const count = await query.count()
    setLimit(query, count)
    const result = await query.find()

    return result.map((parseObject: any) =>
      EventCategories.convertFromParseObject(parseObject)
    )
  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function getEventCategoryById(objectId: string): Promise<EventCategoriesModel> {
  try {
    const query = new Parse.Query(EVENT_CATEGORIES_TABLE)
    const parseObject = await query.get(objectId)
    const result = EventCategories.convertFromParseObject(parseObject)
    return result

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function addOrUpdateEventCategory(newCategory: EventCategoriesModel): Promise<void> {
  try {
    const Category = EVENT_CATEGORIES_TABLE
    const category = new Category()
    Object.entries(newCategory)
      .filter((key) => !filterKeys.includes(key[0]))
      .forEach((key) => {
        category.set(key[0], key[1])
      })
    await category.save()

  } catch (error) {
    handleError(error)
    throw error
  }
}

export async function deleteCategory(objectId: string): Promise<void> {
  try {
    const query = new Parse.Query(EVENT_CATEGORIES_TABLE)
    query.get(objectId)
    const result = await query.find()
    if (result.length >= 1) {
      await result[0].destroy()
    }

  } catch (error) {
    handleError(error)
    throw error
  }
}
